export default "__VITE_ASSET__CvekOF9E__"